// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd8ac06d","453":"cae981de","455":"773d1dd9","977":"06ce55fd"}[chunkId] + ".chunk.js";
};